import React from "react";

const options = [
  {
    id: 1,
    icon: <img src="/BuzzCom/images/calender.svg" alt="calender" />,
  },
  {
    id: 2,
    icon: <img src="/BuzzCom/images/contacts.svg" alt="contacts" />,
  },
  {
    id: 3,
    icon: <img src="/BuzzCom/images/tools.svg" alt="tools" />,
  },
  {
    id: 4,
    icon: <img src="/BuzzCom/images/notepad.svg" alt="tools" />,
  },
];
const BuzzSideNav = () => {
  return (
    <>
      {options.map((option) => {
        return (
          <div
            className="buzzSideNavItem d-flex flex-justify-center"
            id={option.id}
          >
            <div>{option.icon}</div>
          </div>
        );
      })}
    </>
  );
};

export default BuzzSideNav;
